import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate, formateDateWithMonth, getFormatedTime, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { subscribeForPremium, subscriptionHistoryList, unsubscribeFromPremium, userDetails } from "../../services/user.service";
import Swal from "sweetalert2";
import { SUBSCRIPTION_NAMES, SUBSCRIPTION_PRODUCT_IDS, SWAL_SETTINGS } from "../../../../utils/Constants";

const UserView = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const params = useParams();
    // const [query] = useSearchParams();
    const [showdefault, setShowDefault] = useState({});
    const [statsupdate, setStatusUpdate] = useState("false");
    const [activeTab, setActiveTab] = useState("details");
    const [subscriptionList, setSubscriptionList] = useState([]);

    const breadcrumbs = [
        { title: t("link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("User"),
            url: "/admin/user-management/user/list/1",
        },
        { title: t("View"), url: "" },
    ];

    useEffect(() => {
        userDetails(params.id)
            .then((response) => {
                // console.log("View response-", response);
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id, statsupdate]);

    const handleSubscriptionHistory = () => {
        subscriptionHistoryList(params.id)
            .then((response) => {
                setSubscriptionList(response?.data?.list);
            })
            .catch((err) => {
                console.log("Err===>", err);
            });
    };

    const SubscribePremiumPlan = (o_id, plan_slug) => {
        Swal.fire({
            customClass: "swal-wide",
            title: t(`Assign ${plan_slug} plan to this user?`),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
        }).then((result) => {
            if (result.isConfirmed) {
                subscribeForPremium({ o_id: o_id, plan_slug: plan_slug })
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };
    const UnsubscribePremiumPlan = (o_id) => {
        Swal.fire({
            customClass: "swal-wide",
            title: t(`Are you sure you want to unsubscribe this user from the premium plan?`),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
        }).then((result) => {
            if (result.isConfirmed) {
                unsubscribeFromPremium({ o_id: o_id })
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <ul className="nav nav-tabs mb-2 mt-3 ms-4">
                            <li className="nav-item">
                                <button className={`nav-link ${activeTab === "details" ? "active" : ""}`} onClick={() => setActiveTab("details")}>
                                    {t("View Details")}
                                </button>
                            </li>
                            <li className="nav-item">
                                <button className={`nav-link ${activeTab === "subscriptionPlan" ? "active" : ""}`} onClick={() => setActiveTab("subscriptionPlan")}>
                                    {t("Subscription Plan")}
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "subscriptionHistory" ? "active" : ""}`}
                                    onClick={() => {
                                        setActiveTab("subscriptionHistory");
                                        handleSubscriptionHistory();
                                    }}
                                >
                                    {t("Subscription History")}
                                </button>
                            </li>
                        </ul>

                        <div className="card-body">
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    {activeTab === "details" && (
                                        <div className="col-lg-12 form-group">
                                            <table id="simple-table" className="table table-bordered table-hover">
                                                <tbody>
                                                    {/* Profile Info Table (excluding subscription) */}
                                                    <tr>
                                                        <th>{t("Image")}</th>
                                                        <td>
                                                            <img src={showdefault?.profile_image || "N/A"} alt="profile" style={{ height: "100px" }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>{t("Name")}</th>
                                                        <td className="text-capitalize">{showdefault?.name || "N/A"}</td>
                                                    </tr>
                                                    {showdefault?.email && (
                                                        <tr>
                                                            <th>{t("label_email")}</th>
                                                            <td>{showdefault?.email || "N/A"}</td>
                                                        </tr>
                                                    )}
                                                    {showdefault?.phone_number && (
                                                        <tr>
                                                            <th>{t("label_phone_number")}</th>
                                                            <td>{showdefault?.phone_number || "N/A"}</td>
                                                        </tr>
                                                    )}
                                                    <tr>
                                                        <th>{t("Gender")}</th>
                                                        <td>{showdefault?.gender || "N/A"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{t("Date of Birth")}</th>
                                                        <td>{showdefault?.date_of_birth ? formateDate(showdefault.date_of_birth) : "N/A"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{t("Time of Birth")}</th>
                                                        <td>{showdefault?.time_of_birth ? (showdefault.time_of_birth) : "N/A"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{t("Place of birth")}</th>
                                                        <td>{showdefault?.place_of_birth || "N/A"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{t("list_heading_created_date")}</th>
                                                        <td>{showdefault?.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    {/* Separate Subscription Plan Section */}
                                    {activeTab === "subscriptionPlan" && (
                                        <div className="col-lg-12">
                                            <div className="card shadow-sm border">
                                                <div className="card-body">
                                                    <h5 className="mb-3">{t("Subscription Plan")}</h5>

                                                    {/* Extract values for clarity */}
                                                    {(() => {
                                                        const currentSlug = showdefault?.plan_slug || "free";
                                                        const expiryDate = showdefault?.subscription_expires_at
                                                            ? new Date(showdefault.subscription_expires_at)
                                                            : null;
                                                        return (
                                                            <>
                                                                <p>
                                                                    <strong>{t("Current Plan")}:</strong> {capitalizeFirstLetter(currentSlug)}
                                                                </p>
                                                                <p>
                                                                    <strong>{t("Expiry Date")}:</strong>{" "}
                                                                    {expiryDate ? expiryDate.toLocaleDateString() : t("No expiry")}
                                                                </p>
                                                                <p className="mb-2">{t("Assign a plan:")}</p>
                                                                <select
                                                                    className="form-select w-auto d-inline-block me-2"
                                                                    onChange={(e) => {
                                                                        const newPlan = e.target.value;
                                                                        if (!newPlan) return;
                                                                        SubscribePremiumPlan(showdefault._id, newPlan);
                                                                    }}
                                                                    defaultValue=""
                                                                >
                                                                    <option value="" disabled>{t("Select a plan")}</option>
                                                                    <option value="free">FREE</option>
                                                                    <option value="basic">BASIC</option>
                                                                    <option value="advanced">ADVANCED</option>
                                                                    <option value="premium">PREMIUM</option>
                                                                </select>
                                                                {currentSlug !== "free" && (
                                                                    <button className="btn btn-danger mt-2 ms-2" onClick={() => UnsubscribePremiumPlan(showdefault._id)}>
                                                                        {t("Move to FREE")}
                                                                    </button>
                                                                )}
                                                            </>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* subscription history section */}

                                    {activeTab === "subscriptionHistory" && subscriptionList?.length > 0 && (
                                        <div className="">
                                            <h5>{t("Subscription History")}</h5>
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>{t("Plan Type")}</th>
                                                        <th>{t("Start Date")}</th>
                                                        <th>{t("Expiry Date")}</th>
                                                        <th>{t("Status")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {subscriptionList?.map((subscriptionPlan) => (
                                                        <tr key={subscriptionPlan._id}>
                                                            <td>{subscriptionPlan?.plan_slug}</td>
                                                            <td>{formateDateWithMonth(subscriptionPlan?.start_at || subscriptionPlan?.start_date)}</td>
                                                            <td>{formateDateWithMonth(subscriptionPlan?.expires_at || subscriptionPlan?.end_date)}</td>
                                                            <td>{subscriptionPlan?.status}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    {/* Questionnaire */}
                                    {activeTab === "questionnaire" && showdefault?.question_set?.length > 0 && (
                                        <div className="">
                                            <h5>{t("Profile Questionnaire")}</h5>
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>{t("Question")}</th>
                                                        <th>{t("Answer")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {showdefault?.question_set?.map((questionAns, index) => {
                                                        const matchedOptions = questionAns?.question?.option.filter((opt) => questionAns.option.includes(opt.option_slug));
                                                        return (
                                                            <tr key={index}>
                                                                <td>{questionAns?.question?.question_title}</td>
                                                                <td>
                                                                    <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                                                        {matchedOptions?.map((opt, idx) => (
                                                                            <li key={idx}>{opt.option_value}</li>
                                                                        ))}
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <Loader />
                            )}
                        </div>

                        {/* Back Button */}
                        <div className="mt-2 back-button">
                            <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserView;
